import { render } from "./ListaUsuariosComponent.vue?vue&type=template&id=dfab296a&scoped=true"
import script from "./ListaUsuariosComponent.vue?vue&type=script&lang=js"
export * from "./ListaUsuariosComponent.vue?vue&type=script&lang=js"

import "./ListaUsuariosComponent.vue?vue&type=style&index=0&id=dfab296a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfab296a"]])

export default __exports__